import angular from 'angular';
import constants from 'app/constants';
import {
  docDataService,
  oversightDataService,
  oversightSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import markAgendaItemCompleteConfirmDialog from './dialog.markAgendaItemCompleteConfirmDialog';
import editAgendaItemDialog from './dialog.editAgendaItemDialog';
import addAgendaItemNoteDialog from './dialog.addAgendaItemNoteDialog';
import attachAgendaItemDialog from './dialog.attachAgendaItemDialog';
import controller from './category-item.controller';
import directive from './category-item.directive';
import subItem from './subItem';
import itemContent from './itemContent';


export default angular.module('app.components.advisory.oversight.agendaItems', [
  alerts,
  oversightDataService,
  oversightSharedModelService,
  confirmDialog,
  constants,
  markAgendaItemCompleteConfirmDialog,
  editAgendaItemDialog,
  addAgendaItemNoteDialog,
  attachAgendaItemDialog,
  subItem,
  itemContent,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('categoryItem', directive)
  .controller('CategoryItemController', controller)
  .name;

console.log('app.components.advisory.oversight.categoryItem created');
